import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { ObjetivoVendaCadastroComponent } from './objetivo-venda-cadastro/objetivo-venda-cadastro.component';
import { ObjetivoVendaFiltroComponent } from './objetivo-venda-filtro/objetivo-venda-filtro.component';
import { ObjetivoVendaListaComponent } from './objetivo-venda-lista/objetivo-venda-lista.component';
import { ObjetivoVendaService } from './objetivo-venda-service/objetivo-venda.service';
import { ObjetivoVendaComponent } from './objetivo-venda.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    ObjetivoVendaComponent
  ],
  declarations: [
    ObjetivoVendaComponent,
    ObjetivoVendaCadastroComponent,
    ObjetivoVendaListaComponent,
    ObjetivoVendaFiltroComponent
  ],
providers: [
  ObjetivoVendaService
]
})
export class ObjetivoVendaModule { }
